import React, { Component } from "react";
import Pagination from "react-js-pagination";
import PropTypes from "prop-types";
import {SERP_RESULTS_LIMIT} from "../../constants/ConfigFromBuildEnvironment";
import EventPublisher from "../../utils/EventPublisher";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";


export default class PrivateSERPResultsPagination extends Component {
    static propTypes = {
        totalCount: PropTypes.number.isRequired,
        activePage: PropTypes.number.isRequired,
    };

    handlePageChange(pageNumber) {
        EventPublisher.publish(UIInteractionEvents.PAGINATION_CHANGE, pageNumber);
    }

    render() {
        return (
            <div className="">
                <Pagination
                    activePage={this.props.activePage}
                    itemsCountPerPage={parseInt(SERP_RESULTS_LIMIT)}
                    totalItemsCount={this.props.totalCount}
                    hideNavigation={true}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                    itemClass="page-item"
                    linkClass="page-link"/>
            </div>);
    }
}